<template>
  <div class="page-container">
    <div class="page_title">
      <div class="page_title_desc">电话通知商品配置</div>
    </div>
    <el-divider></el-divider>
    <el-button
      size="small"
      type="primary"
      @click="handleAddGoods"
      style="margin-bottom: 10px"
      >添加商品</el-button
    >
    <el-table :data="goodsList" stripe size="small" style="width: 100%">
      <el-table-column
        label="序号"
        width="50"
        align="center"
        fixed
        type="index"
      ></el-table-column>
      <el-table-column
        label="通知次数"
        align="center"
        width="120"
        prop="noticeCount"
      ></el-table-column>
      <el-table-column
        label="购买价格(元)"
        align="center"
        width="120"
        prop="buyPrice"
      ></el-table-column>
      <el-table-column
        label="显示原价(元)"
        align="center"
        width="120"
        prop="originalPrice"
      ></el-table-column>
      <el-table-column
        label="标签展示"
        align="center"
        prop="goodsLabel"
      ></el-table-column>
      <el-table-column
        label="上架位置"
        align="center"
        prop="goodsNum"
      ></el-table-column>
      <el-table-column
        label="上架时间"
        align="center"
        prop="createTime"
      ></el-table-column>
      <el-table-column
        label="操作人"
        align="center"
        prop="createUser"
      ></el-table-column>
      <el-table-column label="操作" align="center" prop="operation">
        <template slot-scope="scope">
          <el-button type="text" size="small" @click="handleEdit(scope.row)"
            >编辑</el-button
          >
          <el-button type="text" size="small" @click="handleDelete(scope.row)"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      background
      layout="total, prev, pager, next"
      @current-change="refreshPageRequest"
      :current-page="pageNo"
      :page-size="pageSize"
      :total="totalSize"
      style="float: right;padding: 10px;"
    ></el-pagination>
    <el-dialog
      :visible.sync="isShowGoodsDialog"
      v-if="isShowGoodsDialog"
      :title="goodsTitle"
      width="500px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <el-form
        :model="goodForm"
        label-width="100"
        size="small"
        :rules="goodFormRule"
        ref="goodForm"
      >
        <el-form-item label="通知次数：">
          <el-input-number
            size="small"
            v-model.number="goodForm.noticeCount"
            :min="1"
            controls-position="right"
          ></el-input-number>
        </el-form-item>
        <el-form-item label="购买价格(元)：" prop="buyPrice">
          <el-input
            v-model="goodForm.buyPrice"
            clearable
            placeholder="请输入购买价格"
            style="width: 200px"
          ></el-input>
        </el-form-item>
        <el-form-item label="显示原价(元)：" prop="originalPrice">
          <el-input
            v-model="goodForm.originalPrice"
            clearable
            placeholder="请输入显示原价"
            style="width: 200px"
          ></el-input>
        </el-form-item>
        <el-form-item label="标签显示：" prop="goodsLabel">
          <el-radio-group v-model="goodForm.goodsLabel">
            <el-radio label="原价">原价</el-radio>
            <el-radio label="特惠">特惠</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="上架位置：" prop="goodsNum">
          <el-select
            v-model="goodForm.goodsNum"
            clearable
            placeholder="请选择上架位置"
          >
            <el-option v-for="item in 6" :key="item" :value="item"></el-option>
          </el-select>
          <el-popover
            placement="right"
            title="位置描述"
            width="200"
            trigger="hover"
            style="margin-left:20px"
          >
            <div class="position-desc">
              <div v-for="item in 6"  :key="item">{{item}}</div>
            </div>
            <el-button slot="reference" type="text" size="small">查看</el-button>
          </el-popover>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button size="small" @click="handleCancel">取消</el-button>
        <el-button size="small" type="primary" @click="handleConfirm">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      goodsList: [],
      pageNo: 1,
      pageSize: 10,
      totalSize: null,
      goodForm: {},
      goodsTitle: null,
      isShowGoodsDialog: false,
      goodFormRule: {
        buyPrice:[{
          required:true , validator:this.validPrice('buyPrice')
        }],
        originalPrice:[{
          required:true ,validator:this.validPrice('originalPrice')
        }],
        goodsLabel:[{
          required:true ,message :'请选择标签'
        }],
        goodsNum:[{
          required:true, message:'请选择上架位置'
        }]
      },
    };
  },
  created() {},
  mounted() {
    this.getAllGoodsList();
  },
  methods: {
    validPrice(type){
      return (rule, value ,callback) => {
        if(!value){
          return callback(new Error(`请输入${type ==='originalPrice' ? '显示原价'  :'购买价格'}`))
        }
        if(!Number(value)){
          return callback(new Error('请输入正确金额类型'))
        }
        return callback()
      }
    },
    handleAddGoods() {
      this.goodsTitle = "新建商品";
      this.goodForm = {
        noticeCount:1
      }
      this.isShowGoodsDialog = true;
    },
    async getAllGoodsList() {
      let params = {
        pageSize: this.pageSize ,
        pageNo: this.pageNo
      }
      let res  = await this.$api.phoneService.mGetGoodsList(params)
      this.goodsList = res.data.dtoList
      this.totalSize = res.data.totalSize

    },
    refreshPageRequest(val) {
      this.pageNo = val;
      this.getAllGoodsList();
    },
    handleEdit(row) {
      console.log(row);
      this.goodForm = row
      this.goodsTitle = "编辑商品";
      this.isShowGoodsDialog = true;
    },
    handleDelete(row) {
      this.$confirm('确认删除该商品吗？','提示',{
        type: 'warning'
      }).then(async (res) => {
        await this.$api.phoneService.deleteGoods({
          id: row.id
        })
        
        this.$message({
          message:'删除成功！',
          offset: 300,
          type: 'success'
        })
        this.getAllGoodsList()
      }).catch((rej) => {
        
      })
    },
    handleCancel(){
      this.isShowGoodsDialog = false
      this.goodForm = {}
    },
    handleConfirm(){
      // this.isShowGoodsDialog = false
      this.$refs.goodForm.validate(async (valid) => {
        if(valid){
          let action = this.goodForm.id ? 'updateGoods' : 'addGoods'
          await this.$api.phoneService[action]({
            ...this.goodForm
          })
          this.$message({
            type: 'success',
            offset:300 ,
            message: `${this.goodForm.id ?  '更新成功' : '新增成功'}`
          })
          
          this.isShowGoodsDialog = false
          this.goodForm = {}
          this.getAllGoodsList()
        }
      })
      
    }
  },
};
</script>

<style lang="scss" scoped>
.page-container{
  box-sizing: border-box;
  padding: 10px;
}
.position-desc{
  width:100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  div{
    width: 30%;
    height: 100px;
    margin: 0 0 10px;
    border: 1px solid #ccc;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
</style>